import * as Sentry from "@sentry/browser";

export const errorHandler = response => {
  if (
    response &&
    response.data &&
    response.data.errors &&
    response.data.errors.join(",") == "Access token expired" &&
    response.status == 401
  ) {
    // Access Token expired therefore logout user
    localStorage.clear();
  } else if (
    (response &&
      response.status &&
      response.status !== 404 &&
      response.status !== 422 &&
      response.status !== 401) ||
    (response &&
      response.response &&
      response.response.status !== 404 &&
      response.response.status !== 422 &&
      response.response.status !== 401)
  ) {
    Sentry.captureException(response);
  }
};



// WEBPACK FOOTER //
// ./src/utils/errorHandler.js